const privacy = {
  title: () => 'Shop italist | Read our privacy policy',
  description: () =>
    'Please read our Privacy Policy carefully since we are offering direct-to-consumer imports of worldwide fashion luxury products exclusively from Italy'
};

export default privacy;
